export const TRADE_HIDE = 13
export const TRADE_PUBLIC = 3
export const TRADE_DONT_HAPPEND = 10
export const TRADE_HAPPEND = 12
export const TRADE_CANCEL = 5
export const TRADE_EXTEND = 7
export const TRADE_OPEN = 6
export const DELETE_BEFORE_PUBLIC = 2
